// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__lNPXM","container":"styles_container__1a3ju","title":"styles_title__3hhub","wrapper":"styles_wrapper__2rnK2","answer":"styles_answer__1rj_h"};